<div [style.width.px]="this._plantilla.navbarOpen ? 350 : 0" class="sidenav" id="mySidenav">
  <a (click)="closeNav()" class="closebtn" href="javascript:void(0)">Menú &times; </a>

  <div *ngFor="let item of menus" class="test nav navbar-nav d-md-down-none">

    <li (click)="closeNav()" *ngIf="item.redirectTo" auto-hide="false" class="animated fadeIn ">
      <a [routerLink]="item.redirectTo" routerDirection="root" routerLinkActive="active">
        <i aria-hidden="true" class="fa fa-caret-right"></i> {{ item.name}}</a>
    </li>

    <!-- VALIDA QUE LA LINEA TENGA SUB-MENU NIVEL 1-->
    <div *ngIf="item.children?.length > 0">
      <li (click)="item.open = !item.open" [class.active-parent]="item.open" auto-hide="false" class="animated fadeIn"
          detail="false">
        <a>
          <i *ngIf="!item.open" aria-hidden="true" class="fa fa-plus"></i>
          <i *ngIf="item.open" aria-hidden="true" class="fa fa-minus"></i> {{ item.name }}</a>
      </li>
    </div>


    <div *ngIf="item.open" class="animated fadeInLeft">
      <ul *ngFor="let sub of item.children " class="animated fadeIn nav navbar-nav " data-toggle="collapse">
        <li class="nav-item px-3">
          <a (click)="closeNav()" *ngIf="sub.redirectTo" [routerLink]="sub.redirectTo" routerDirection="root"
             routerLinkActive="active">
            <i aria-hidden="true" class="fa fa-caret-right"></i> {{ sub.name }}
          </a>
        </li>
        <li class="nav-item px-3">
          <!--MENU 2-->
          <a (click)="sub.open = !sub.open" *ngIf="sub.children?.length > 0" [class.active-parent]="sub.open"
             class="animated fadeIn">
            <i *ngIf="!sub.open" aria-hidden="true" class="fa fa-plus"></i>
            <i *ngIf="sub.open" aria-hidden="true" class="fa fa-minus"></i> {{ sub.name }}
          </a>        
          <!--MENU 3-->
          <div *ngIf="sub.open" class="animated fadeInLeft">
            <ul class="animated fadeIn nav navbar-nav" data-toggle="collapse">
              <li (click)="closeNav()" *ngFor="let sub1 of sub.children " class="nav-item px-3">
                <a (click)="closeNav()" [routerLink]="sub1.redirectTo" routerDirection="root"
                   routerLinkActive="active">
                  <i aria-hidden="true" class="fa fa-caret-right"></i> {{sub1.name}}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
